import { Injectable, EventEmitter } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { RestAngularConfig } from '../../service/restAngular/rest-angular-config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {AuthGuard} from "../../service/auth-guard.service";
import {Config} from "../../config";


@Injectable()
export class SavedFilesApi {

  confirmDelete = new EventEmitter();
  private authToken: string;

  constructor(private restangular: Restangular, private httpClient: HttpClient) {
    this.authToken = AuthGuard.readCookie('AuthToken') || localStorage.getItem('AuthToken');
    RestAngularConfig.RestangularProvider.setDefaultHeaders({'Authorization': 'JWT ' + this.authToken});
  }

  save(data, filetype, filename) {
    return this.restangular.all('saved-recommendations/').post({
      'recommendations_type': filetype,
      'recommendations_data': data,
      'name': filename,
      'file_name': filename
    });
  }

  getFiles(page = 1) {
      return this.restangular.one('saved-recommendations/?page=' + page).get();
  }

  delete(id: number) {
    const headers = new HttpHeaders({'Authorization': 'JWT ' + this.authToken});
    const url = Config.BASE_URL + 'saved-recommendations/' + id + '/';
    return this.httpClient.delete(url, {headers: headers});
  }

}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/saved-files/saved-files.api.ts